import { render } from "./OrderChit.vue?vue&type=template&id=6cb5a338&scoped=true"
import script from "./OrderChit.vue?vue&type=script&lang=js"
export * from "./OrderChit.vue?vue&type=script&lang=js"

import "./OrderChit.vue?vue&type=style&index=0&id=6cb5a338&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb5a338"]])

export default __exports__